<template>
	<div class="all-customers">
		<BlockFiltersModal
			:data="DataFiltersModal"
			:filtrationInProgress="filtrationInProgress"
			:isFilterHidden="filtrationInProgress"
			@startFiltration="startFiltration"
			@resetFiltration="resetFiltration"
		/>

		<div class="all-customers__list">
			<div class="container customers-table">
				<div class="customers-table__header">
					<div class="customer-table__title">
						<h1 class="section-title section-title--customers-table" >Archived Customers</h1>
					</div>
					<div class="notification-wrap-center">
						<PartNotifications :data="notificationsData" v-if="notificationsData.msg" />
					</div>
					<div class="customer-table__buttons">
						<router-link class="btn btn--white btn--lg" :to="{ name: goInDashboard() ? 'LeadsDashboardAdmin' : 'LeadsDashboardAgent' }">
							My Leads Dashboard
						</router-link>
						<router-link class="btn btn--mid btn--icon customer-table__button" :to="{ name: goInDashboard() ? 'NewCustomerAdmin' : 'NewCustomerAgent' }">
							<SvgIcon class="btn-icon" iconName="ico-plus"/>
							<span>Add New</span>
						</router-link>
					</div>
				</div>
				<div class="all-customer-wrap__header">
					<router-link class="all-customer-wrap__header-link" id="published_customer-button" :to="{ name: goInDashboard() ? 'CustomersAdmin' : 'CustomersAgent' }">
						<SvgIcon class="all-customer-wrap__icon all-customer-wrap__icon--list" iconName="ico-clipboard-list"/>
						<span class="all-customer-wrap__header-inner">
							<span>Published Customers </span>
							<span>(<span>{{ allTotals ? allTotals.total_active : 0 }}</span>)</span>
						</span>
					</router-link>
					<router-link class="all-customer-wrap__header-link is-active-link" id="draft_customer-button" :to="{ name: goInDashboard() ? 'ArchivedCustomersAdmin' : 'ArchivedCustomersAgent' }">
						<SvgIcon class="all-customer-wrap__icon" iconName="ico-archive-filled"/>
						<span class="all-customer-wrap__header-inner">
							<span>Archived Customers </span>
							<span>(<span>{{ allTotals ? allTotals.total_archived : 0 }}</span>)</span>
						</span>
					</router-link>
					<router-link class="all-customer-wrap__header-link" id="trash_customer-button" :to="{ name: goInDashboard() ? 'DeletedCustomersAdmin' : 'DeletedCustomersAgent' }" v-if="checkPermissions()">
						<SvgIcon class="all-customer-wrap__icon" iconName="ico-trash"/>
						<span class="all-customer-wrap__header-inner">
							<span>Deleted Customers </span>
							<span>(<span>{{ allTotals ? allTotals.total_deleted : 0 }}</span>)</span>
						</span>
					</router-link>
				</div>
				<div class="customers-table__content table-wrap" :class="{'table-empty': noResults}">
					<BlockTable
						v-if="!noResults"
						@getPage="getPage"
						:data="tableData"
						@sortData="sortCustomers"
						@restoreRow="restoreRow"
						@deleteRow="deleteRow"
						:sort="localOrderBy"
						:order="localOrder === 'desc'"
					/>
					<PartLoaderBig class="loader-table" v-if="preloader"/>

					<PartNoResults :data="DataNoResults" v-if="noResults && !preloader"/>

					<!-- <PartPagination
						ref="pagination"
						v-show="!preloader && showPagination"
						@getPage="getPage"
					/> -->
				</div>
				<PartPopupDelete
					v-if="showPopupDelete"
					:data="PopupDelete"
					@confirmPopupDelete="confirmPopupDelete"
					@closePopupDelete="closePopupDelete"
				>
					<template v-slot:popupTitle>Are you sure you want to delete this customer?</template>
					<template v-slot:popupCancel>No</template>
					<template v-slot:popupConfirm>Yes</template>
				</PartPopupDelete>
			</div>
		</div>
	</div>
</template>

<script>
import BlockFiltersModal from '@/components/blocks/BlockFiltersModal';
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import BlockTable from '@/components/blocks/BlockTable';
import PartLoaderBig from '@/components/parts/PartLoaderBig';
// import PartPagination from '@/components/parts/PartPagination';
import PartPopupDelete from '@/components/parts/PartPopupDelete';
import PartNotifications from '@/components/parts/PartNotifications';
import PartNoResults from '@/components/parts/PartNoResults';
import { check } from '@/services/RouteGuards/SuperAdmin';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},

	components: {
		BlockFiltersModal,
		SvgIcon,
		BlockTable,
		PartLoaderBig,
		// PartPagination,
		PartPopupDelete,
		PartNoResults,
		PartNotifications
	},

	data: function () {
		return {
			DataNoResults: {},
			filter: {},
			preventGetPage: false,
			initialFetch: false,
			filtrationInProgress: false,
			DataFiltersModal: {
				isCustomer: true,
				DataListingStatus: {},
				DataListingType: {},
				DataEndUser: {
					label: 'End User:',
					labelId: 'checkbox-filter-end-user-label',
					lists: [
						{
							id: 'filter_end-user_customers',
							checked: 'false',
							value: 'end-user',
							for: 'filter_end-user_customers',
							label: 'End User'
						}
					]
				},
				DataDateListed: {
					inputId: 'date_listed-commercial-input',
					labelId: 'date_listed-commercial-label',
					flag: 'date_listed',
					mandatoryFiled: false,
					today: ''
				},
				DataDateVerified: {
					inputId: 'date_verified-commercial-input',
					labelId: 'date_verified-commercial-label',
					flag: 'date_verified',
					mandatoryFiled: false,
					today: ''
				},
				DataInputSearch: {
					inputId: 'customers-search-input',
					label: 'Search',
					labelId: 'customers-search-label',
					placeholder: 'Search...',
					searchClass: 'customers-search',
					type: 'text'
				},
				DataOfferingType: {
					label: 'Offering Type',
					labelId: 'offering-type-customer-label',
					inputId: 'offering-type-customer-input',
					placeholder: 'Add Type',
					mandatoryFiled: false,
					options: [],
					multiple: true
				},
				DataArea: {
					label: 'Area',
					labelId: 'area-customer-label',
					inputId: 'area-customer-input',
					placeholder: 'Add Area',
					mandatoryFiled: false,
					multiple: true,
					options: []
				},
				DataPropertyType: {
					label: 'Property Type',
					labelId: 'type-customer-label',
					inputId: 'type-customer-input',
					placeholder: 'Add Type',
					mandatoryFiled: false,
					multiple: true,
					options: []
				},
				DataAssignedAgent: {
					label: 'Assigned Agent',
					labelId: 'user-commercial-label',
					inputId: 'user-commercial-input',
					placeholder: 'Add Agent',
					mandatoryFiled: false,
					options: [],
					multiple: true
				},
				DataBuildingSize: {
					labelId: 'building-size-customer-label',
					label: 'Building Size',
					iconName: 'ico-buildings',
					classIcon: 'input-icon-box input-icon-box--big',
					placeholder: 'Enter Building Size'
				},
				DataLotSize: {
					labelId: 'lot-size-customer-label',
					label: 'Lot Size',
					iconName: 'ico-buildings',
					classIcon: 'input-icon-box input-icon-box--big',
					placeholder: 'Enter Lot Size'
				},
				DataPrice: {
					labelId: 'price-customer-label',
					label: 'Price',
					iconName: 'ico-dollar-sign',
					classIcon: 'input-icon-box',
					currency: true,
					placeholder: 'Enter Price'
				},
				DataYearlyPrice: {
					label: 'Yearly Price per Square Foot',
					placeholder: 'Enter Yearly Price',
					iconName: 'ico-dollar-sign',
					classIcon: 'input-icon-box',
					inputId: 'yearly_price-custumer-input',
					labelId: 'yearly_price-customer-label',
					mandatoryFiled: false
				},
				DataPriceBuildableSquareFoot: {
					labelId: 'price-buildable-sf-customer-label',
					label: 'Price per Buildable Square Foot',
					iconName: 'ico-dollar-sign',
					classIcon: 'input-icon-box',
					currency: true,
					placeholder: 'Enter Price'
				},
				DataPriceSquareFoot: {
					labelId: 'price-per-sf-customer-label',
					label: 'Price per Square Foot',
					iconName: 'ico-dollar-sign',
					classIcon: 'input-icon-box',
					currency: true,
					placeholder: 'Enter Price'
				},
				DataLeasePrice: {
					labelId: 'lease_price-customer-label',
					label: 'Lease Price',
					iconName: 'ico-dollar-sign',
					classIcon: 'input-icon-box',
					currency: true,
					placeholder: 'Enter Price'
				},
				DataSource: {
					type: 'text',
					inputId: 'source-input',
					placeholder: 'Lead Source',
					label: 'Lead Source',
					labelId: 'source-label',
					searchClass: 'customers-search'
				}
			},
			notificationsData: {
				type: '',
				msg: ''
			},
			noResults: true,
			PopupDelete: {
				itemID: ''
			},
			showPopupDelete: false,
			classScroll: 'prevent-scroll',
			// showPagination: false,
			preloader: true,
			localOrder: 'asc',
			localOrderBy: 'last_name_customer',
			defaultOrder: 'asc',
			defaultOrderBy: 'last_name_customer',
			tableData: {
				stickyHeader: true,
				noCollapse: false,
				noLocalSorting: true,
				tableClass: 'text-nowrap',
				fields: [
					{ key: 'last_name_customer', label: 'Name', sortable: true, stickyColumn: true, variant: 'property thead-lg' },
					{ key: 'company_name', label: 'Company Name', sortable: true, stickyColumn: true, variant: 'company-name' },
					{ key: 'offering_type_customer', label: 'Offering Type', sortable: true, stickyColumn: true, variant: 'service-type' },
					{ key: 'area', label: 'Area', sortable: true, stickyColumn: true, variant: 'area' },
					{ key: 'critical_note', label: 'Critical Notes', sortable: true, stickyColumn: true, variant: 'critical-notes' },
					{ key: 'property_type_customer', label: 'Type', sortable: true, stickyColumn: true, variant: 'type' },
					{ key: 'building_size_min', label: 'Bldg Size Min', sortable: true, stickyColumn: true, variant: 'building-size' },
					{ key: 'building_size_max', label: 'Bldg Size Max', sortable: true, stickyColumn: true, variant: 'building-size' },
					{ key: 'lot_size_min', label: 'Lot Size Min', sortable: true, stickyColumn: true, variant: 'lot-size' },
					{ key: 'lot_size_max', label: 'Lot Size Max', sortable: true, stickyColumn: true, variant: 'lot-size' },
					{ key: 'price_min', label: 'Price Min', sortable: true, stickyColumn: true, variant: 'price' },
					{ key: 'price_max', label: 'Price Max', sortable: true, stickyColumn: true, variant: 'price' },
					{ key: 'price_buildable_sf_min', label: 'Price per Buildable SF Min', sortable: true, stickyColumn: true, variant: 'price-buildable-sf' },
					{ key: 'price_buildable_sf_max', label: 'Price per Buildable SF Max', sortable: true, stickyColumn: true, variant: 'price-buildable-sf' },
					{ key: 'price_psf_min', label: 'Price per SF Min', sortable: true, stickyColumn: true, variant: 'price-psf' },
					{ key: 'price_psf_max', label: 'Price per SF max', sortable: true, stickyColumn: true, variant: 'price-psf' },
					{ key: 'lease_price_min', label: 'Lease Price Min', sortable: true, stickyColumn: true, variant: 'lease-price' },
					{ key: 'lease_price_max', label: 'Lease Price Max', sortable: true, stickyColumn: true, variant: 'lease-price' },
					{ key: 'yearly_price_min', label: 'Yearly Price per SF Min', sortable: true, stickyColumn: true, variant: 'yearly-price' },
					{ key: 'yearly_price_max', label: 'Yearly Price per SF Max', sortable: true, stickyColumn: true, variant: 'yearly-price' },
					{ key: 'end_user', label: 'End User', sortable: true, stickyColumn: true, variant: 'investor' },
					{ key: 'lead_source', label: 'Source', sortable: true, stickyColumn: true, variant: 'date-source' },
					{ key: 'agent_name', label: 'Agent', sortable: true, stickyColumn: true, variant: 'agent' },
					{ key: 'delete', label: '', sortable: false, stickyColumn: true, variant: 'fixed-icon second-icon-fixed table-fixed-icon--red last-icon-fixed' },
					{ key: 'restore', label: '', sortable: false, stickyColumn: true, variant: 'fixed-icon first-icon-fixed' }
				],
				items: []
			}
		};
	},
	created() {
		const user = JSON.parse(localStorage.getItem('user'));
		if (localStorage.getItem('filter-customers') && JSON.parse(localStorage.getItem('filter-customers')).user_id === user.id) {
			this.filter = JSON.parse(localStorage.getItem('filter-customers')).filter;
		}
		// const obj = {
		// 	filter: this.filter,
		// 	order_by: this.localOrderBy.replace('_customer', ''),
		// 	order: this.localOrder,
		// 	page: 1,
		// 	isFilter: true
		// };
		// this.initialFetch = true;
		// this.$store.dispatch('fetchArchivedCustomers', obj).then(response => {
		// 	this.from = response.data.from;
		// 	this.to = response.data.to;
		// 	this.numOfCustomers = response.data.total_active;
		// 	response.data.customers.forEach((customer, index) => {
		// 		let areaLabel = customer.area_label;
		// 		if (areaLabel.includes('Near Brooklyn')) {
		// 			areaLabel = areaLabel.filter(label => label.trim() !== 'Near Brooklyn');
		// 			areaLabel.push('Near Brooklyn');
		// 		} 
		// 		if (areaLabel.includes('Near Boro Park')) {
		// 			areaLabel = areaLabel.filter(label => label.trim() !== 'Near Boro Park');
		// 			areaLabel.push('Near Boro Park');
		// 		} 
		// 		customer.area_label = areaLabel;

		// 		customer.property_type_label.forEach((label, i) => {
		// 			if (label.search('Comunity') > -1) {
		// 				label = label.replace('Comunity', 'Community');
		// 				customer.property_type_label[i] = label;
		// 			}
		// 		});
		// 	});
		// 	this.initialFetch = false;
		// });
		this.startFiltration(this.filter);
	},
	mounted() {
		this.initDropDowns();
		this.$store.dispatch('getCustomerAssigned').then((res) => {
			this.DataFiltersModal.DataAssignedAgent.options = res.data;
		});

		if (!this.checkPermissions()) {
			this.tableData.fields.forEach((el, index) => {
				if (el.key === 'agent_name') {
					this.tableData.fields.splice(index, 1);
				}
			});
		}
	},
	computed: {
		archivedCustomers() {
			return this.$store.getters.getArchivedCustomers;
		},
		agentArchivedCustomers() {
			return this.$store.getters.getAgentArchivedCustomers;
		},
		allTotals() {
			return this.$store.getters.getCustomersTotals;
		},
		agentArchivedCustomerInfinitResult() {
			return this.$store.getters.getAgentArchivedCustomerInfinitResult;
		},
		archivedCustomerInfinitResult() {
			return this.$store.getters.getArchivedCustomerInfinitResult;
		}
	},
	watch: {
		archivedCustomers() {
			this.noResults = !this.archivedCustomers.length;
			this.preloader = false;
			this.tableData.items = this.archivedCustomers;
		},
		agentArchivedCustomers() {
			this.noResults = !this.agentArchivedCustomers.length;
			this.preloader = false;
			this.tableData.items = this.agentArchivedCustomers;
		}
	},
	methods: {
		initDropDowns() {
			const dropFields = ['offering_type_customer', 'areas', 'property_filter'];
			this.$store.dispatch('fetchDropDownOptions', { values: dropFields }).then((res) => {
				const data = res.data;
				this.DataFiltersModal.DataOfferingType.options = data.offering_type_customer;
				this.DataFiltersModal.DataArea.options = data.areas;
				this.DataFiltersModal.DataPropertyType.options = data.property_filter;
			});
		},
		startFiltration(filter) {
			if (this.filtrationInProgress) {
				return;
			}
			this.filtrationInProgress = true;
			this.preloader = true;
			this.tableData.items = [];
			this.filter = filter;
			const obj = {
				filter: filter,
				order_by: this.localOrderBy.replace('_customer', ''),
				order: this.localOrder,
				page: 1,
				isFilter: true
			};
			this.$store.dispatch('fetchArchivedCustomers', obj).then(response => {
				// this.updatePagination(response.data);
				this.allTotals.total_active = response.data.total_active;
				this.allTotals.total_archived = response.data.total_archived;
				this.allTotals.total_deleted = response.data.total_deleted;
				this.preloader = false;
				this.filtrationInProgress = false;
			});

			// TODO: Adaptive dropdowns go in POST MVP
			// this.$store.dispatch('fetchArchivedCustomers', obj).then(res => {
			// 	if (res.data.adaptive) {
			// 		const data = res.data.adaptive;
			// 		this.DataFiltersModal.DataOfferingType.options = data.offering_type;
			// 		this.DataFiltersModal.DataArea.options = data.areas;
			// 		this.DataFiltersModal.DataPropertyType.options = data.property_type;
			// 	}
			// });
		},
		resetFiltration() {
			if (this.filtrationInProgress) {
				return;
			}
			this.filtrationInProgress = true;
			this.preloader = true;
			this.tableData.items = [];
			this.filter = {};
			this.localOrder = this.defaultOrder;
			this.localOrderBy = this.defaultOrderBy;
			const obj = {
				order_by: this.localOrderBy.replace('_customer', ''),
				order: this.localOrder,
				page: 1,
				isFilter: true
			};
			this.$store.dispatch('fetchArchivedCustomers', obj).then(response => {
				// this.updatePagination(response.data);
				this.numOfCustomers = response.data.total_active;
				this.numOfCustomers = response.data.total_archived;
				this.preloader = false;
				this.filtrationInProgress = false;
			});
			// this.initDropDowns();
		},
		// updatePagination(data) {
		// 	this.$refs.pagination.updateDataPag(data);
		// 	this.checkPagination(data);
		// },
		goInDashboard() {
			return this.$route.fullPath.includes('admin');
		},
		deleteRow(id) {
			this.showPopupDelete = true;
			this.PopupDelete.itemID = id;
			this.$parent.$refs.app.parentNode.classList.add(this.classScroll);
		},
		restoreRow(id) {
			this.restoreCustomer(id);
		},
		closePopupDelete() {
			this.showPopupDelete = false;
			this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
		},
		confirmPopupDelete(id) {
			this.deleteCustomer(id);
			this.showPopupDelete = false;
			this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
		},
		removeRow(id) {
			const index = this.tableData.items.findIndex(i => i.id === id);
			this.tableData.items = this.tableData.items.splice(index, 1);
		},
		restoreCustomer(id) {
			this.$store.dispatch('restoreCustomer', id).then(response => {
				// this.$store.dispatch('fetchArchivedCustomers');
				this.allTotals.total_active = response.data.total_active;
				this.allTotals.total_archived = response.data.total_archived;
				this.allTotals.total_deleted = response.data.total_deleted;
				this.removeRow(id);

				if (undefined !== response.data) {
					this.notification(response);
				}
			});
		},
		deleteCustomer(id) {
			// const obj = {
			// 	order_by: this.localOrderBy,
			// 	order: this.localOrder,
			// 	page: 1,
			// 	filter: this.filter
			// };
			this.$store.dispatch('softDeleteCustomer', id).then(response => {
				// this.$store.dispatch('fetchArchivedCustomers', obj).then(response => {
				// this.$refs.pagination.updateDataPag(response.data);
				// this.checkPagination(response.data);
				// });
				this.allTotals.total_active = response.data.total_active;
				this.allTotals.total_archived = response.data.total_archived;
				this.allTotals.total_deleted = response.data.total_deleted;
				this.removeRow(id);

				if (undefined !== response.data) {
					this.notification(response);
				}
			});
		},
		notification(response) {
			this.notificationsData.msg = response.data.message;
			this.notificationsData.type = response.status === 200 ? 'success' : 'danger';

			setTimeout(() => {
				this.notificationsData.msg = '';
				this.notificationsData.type = '';
			}, 2000);
		},
		fetchNewCustomers(obj) {
			this.preloader = true;
			return this.$store.dispatch('fetchArchivedCustomers', obj);
		},
		sortCustomers(item) {
			this.preventGetPage = true;
			this.tableData.items = [];
			const obj = {
				order_by: item.replace('_customer', ''),
				order: this.SortOrder(item),
				page: 1,
				filter: this.filter,
				isFilter: true
			};
			this.localOrderBy = item;
			this.fetchNewCustomers(obj).then(response => {
				// this.$refs.pagination.updateDataPag(response.data);
				this.preloader = false;
				this.preventGetPage = false;
			});
		},
		SortOrder(item) {
			if (this.localOrderBy.replace('_customer', '') === item.replace('_customer', '')) {
				if (this.localOrder === 'asc') {
					this.localOrder = 'desc';
				} else {
					this.localOrder = 'asc';
				}
			} else {
				this.localOrder = 'asc';
			}
			return this.localOrder;
		},
		getPage() {
			let adminOrAgent;
			(check())
				? adminOrAgent = this.archivedCustomerInfinitResult // set for admin
				: adminOrAgent = this.agentArchivedCustomerInfinitResult;
			
			let nextPage = adminOrAgent.current_page++;
			(adminOrAgent.current_page === 0)
				? nextPage = 1
				: nextPage = adminOrAgent.current_page++;

			if (this.infinitScrollFlag || nextPage > adminOrAgent.last_page || this.preventGetPage === true) {
				return false;
			}

			this.infinitScrollFlag = true;
			const obj = {
				filter: this.filter,
				order_by: this.localOrderBy.replace('_customer', ''),
				order: this.localOrder,
				isFilter: false,
				page: nextPage
			};
			this.fetchNewCustomers(obj).then(response => {
				this.infinitScrollFlag = false;
			});
		},
		// checkPagination(data) {
		// 	this.showPagination = data.prev_page_url !== null || data.next_page_url !== null;
		// },
		checkPermissions() {
			return check();
		}
	}
};
</script>

<style lang="scss" scoped>
.customers-table__content {
	min-height: 50vh;
}
.all-customers {
	padding-bottom: 50px;
}

.all-customers__form-wrap {
	//border-bottom: 1px solid rgba(196, 196, 196, 0.4);
	position: relative;
}
.all-customers__form {
	padding: 24px 5px 3px 0;

	@include mq($lg) {
		padding: 0;
	}
}

.btn.customer-table__button {
	width: 130px;
	min-width: 130px;
	margin-top: -1px;
}

.input__wrapper--select {
	display: flex;
}

.customers-table__header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 30px 0 24px;
	position: relative;

	@include mq(1500px) {
		flex-wrap: wrap;
	}

	@include mq($lg) {
		padding: 20px 0;
	}

	@include mq(660px) {
		flex-direction: column;
	}
}

.section-title--customers-table {
	@include mq(660px) {
		margin-bottom: 10px;
		text-align: center;
	}
}

.customer-table__buttons {
	display: flex;

	a {
		&:not(:first-of-type) {
			margin-left: 17px;

			@include mq(450px) {
				margin-left: 0;
			}
		}
	}

	@include mq(450px) {
		flex-direction: column;
		align-items: center;
		justify-content: center;

		a:not(:last-of-type) {
			margin-bottom: 20px;
		}
	}
}

.title-icon {
	font-size: 15px;

	@include mq(660px) {
		font-size: 13px;
	}
}

.title-icon {
	font-size: 23px;
    margin-right: 5px;
    display: inline-block;
}

.all-customer-wrap__header {
	display: flex;
	margin: 0;
	width: 100%;
	justify-content: space-around;
}

.all-customer-wrap__header-link {
	font-family: $font-main;
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;
	text-align: center;
	color: $shuttle-gray;
	display: flex;
    justify-content: center;
    align-items: center;
    padding: 13px;
	transition: $dur $ease;
	text-decoration: none;
	/*max-width: 33.3%;
	flex: 0 0 33.3%;*/
	width: 100%;
	position: relative;
	background-color: $white-lilac;
	border-right: 1px solid $white;

	@include mq($md) {
		font-size: 14px;
	}

	@include mq(670px) {
		padding: 10px;
		flex-direction: column;
	}

	&::after {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		background-color: $selago;
		width: 1px;
		height: 100%;
		opacity: 0.4;
		transition: $dur $ease;
	}

	&:first-of-type {
		border-top-left-radius: 14px;
	}

	&:last-of-type {
		border-top-right-radius: 14px;
		border-right: none;
		&::after {
			display: none;
		}
	}

	&.is-active-link {
		background-color: $link-water;
		color: $dodger-blue;
	}

	@include hover {
		background-color: $link-water;
		color: $dodger-blue;
	}
}

.all-customer-wrap__icon {
	display: inline-block;
    padding-right: 7px;
	font-size: 14px;
	height: 20px;

	@include mq(670px) {
		display: none;
	}

	svg {
		display: block;
		height: 14px;
	}
}

.all-customer-wrap__icon--list {
	font-size: 11px;
	height: 20px;
}

.all-customer-wrap__header-inner {
	@include mq(670px) {
		flex-direction: column;
		display: flex;
	}
}
.all-customer-btn-wrap {
	width: 160px;
}
</style>
